<template>
  <div>
    <!-- header-->
    <headertop></headertop>
    <el-row class="main" style="padding-top: 1.875rem;">
      <!-- <el-empty description="暂无内容,正在飞快的上传中,尽请期待"></el-empty> -->
      <el-col :span="3" :offset="1">
        <el-table
          :data="list_info.list"
           border
            :row-style="isRed"
          style="width: 100%">
          <el-table-column
            prop="date"
            label="类别"
            >
            <template slot-scope="scope">
              <div style="cursor: pointer;"  @click="handleEdit(scope.row)">{{scope.row.name}}</div>
              <!-- <el-button size="mini" @click="handleEdit( scope.row)"
                          >编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="20" >
        <el-row >
          <span @click="dialogVisible_click()" style="top: 6px;left: 12px;position: absolute;cursor: pointer;color: red;">
            点击全屏查看 </br>
            <span style="color: black;margin-top: 0.25rem;">
              点击链接直接进入课程
            </span></span>
          <iframe
          style="height: calc(100vh - 250px);"
           width=100%  vspale="0" id="childFrame"
           :src="list_info.src" ></iframe>
        </el-row>
      </el-col>
    </el-row>
    <!-- footer -->
    <footerbom></footerbom>
    <el-dialog
      :visible.sync="dialogVisible.show"
      width="100%"
      top="0"
      >
      <iframe
      style="height: calc(100vh - 100px);"
       width=100%  vspale="0" id="childFrame"
       :src="list_info.src" ></iframe>
       <el-table
         :data="list_info.list"
          border
          :row-style="isRed"
           style="width:10%;
            z-index: 999;
             top: 0;
             position: absolute;
             opacity:0.8
         ">
         <el-table-column
           prop="date"
           label="类别"
           >
           <template slot-scope="scope">
             <div style="cursor: pointer;"  @click="handleEdit(scope.row)">{{scope.row.name}}</div>
           </template>
         </el-table-column>
       </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        dialogVisible:{
          show:false
        },
        list_info:{
          num:this.$route.query.num,
          xz_name:[],
          src:'',
          list:[]
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_lesson_map()//地图列表
    },
    methods: {
      dialogVisible_click(){
        this.dialogVisible.show=true
      },
      get_lesson_map(){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/lesson_map", {
          params: {limit:999},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list_info.list=res.data.data.data
              if(_this.list_info.num=='0'){
                _this.handleEdit(_this.list_info.list[0])
              }else{
                for(let i=0;i<_this.list_info.list.length;i++){
                  if(_this.list_info.num==_this.list_info.list[i].file){
                    _this.handleEdit(_this.list_info.list[i])
                    return
                  }
                }
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_list_info(num){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/map_info",
        {params:{file:num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list_info.src=res.data.data
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
       // 编辑事件
          handleEdit(row) {
            this.get_list_info(row.file)
            this.list_info.xz_name = [row]
          } ,
      // 操作表格变色
          isRed({ row }) {
            if(this.list_info.xz_name!=[]){
              const checkIdList = this.list_info.xz_name.map((item) => item.file);
                    if (checkIdList.includes(row.file)) {
                      return {
                        backgroundColor: " rgba(231, 245, 255,0.8)",
                        color: "#008000",
                      };
                    }
            }
          },
    },
  }
</script>

<style scoped>

  /deep/ .el-table tbody tr:hover > td {
    background-color: transparent !important;
    }
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/index/Courses/coursemap.vue